// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Tente novamente usando uma data completa como esta: ' + p['dateExample'] + '.',
  chart_labelGroup: () => 'Grupo',
  chart_labelSeries: () => 'Série',
  chart_labelValue: () => 'Valor',
  checkboxSet_requiredMessageDetail: () => 'Obrigatório',
  checkbox_requiredMessageDetail: () => 'Obrigatório',
  close: () => 'Fechar',
  collection_noData: () => 'Nenhum dado a ser exibido.',
  collection_selectAllRows: () => 'Selecionar todas as linhas',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Selecionar a linha ' + p['ROW_NAME'],
  collection_sortDisabled: () => 'Não classificável',
  collection_sortEnabled: () => 'Classificável',
  confirmation: () => 'Confirmação',
  dataVisualization_labelAndValue: (p: { LABEL: string; VALUE: string }) =>
    p['LABEL'] + ': ' + p['VALUE'],
  dataVisualization_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' de ' + p['totalCount'],
  dataVisualization_noData: () => 'Nenhum dado a ser exibido',
  dataVisualization_stateSelected: () => 'Selecionado',
  dataVisualization_stateUnselected: () => 'Não Selecionado',
  error: () => 'Erro',
  expandableList_expandCollapseInstructionText: () =>
    'Use as teclas de seta para expandir e contrair',
  expandableList_groupCollapse: () => 'Contraído',
  expandableList_groupExpand: () => 'Expandido',
  filePicker_addFiles: () => 'Adicionar Arquivos',
  filePicker_dropzonePrimaryText: () => 'Arrastar e Soltar',
  filePicker_dropzoneSecondaryText: () => 'Selecione um arquivo ou solte um aqui',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Selecione ou solte arquivos aqui',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Não é possível fazer upload de arquivos do tipo ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Faz upload um arquivo por vez',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Não é possível fazer upload de arquivos do tipo ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'desconhecido',
  formControl_clear: () => 'Limpar',
  formControl_day: () => 'Dia',
  formControl_helpAvailable: () => 'Ajuda disponível',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Você atingiu o limite de ' +
    ((
      {
        one: new Intl.NumberFormat('pt').format(p['CHARACTER_LIMIT']) + ' caractere',
        many: new Intl.NumberFormat('pt').format(p['CHARACTER_LIMIT']) + ' caracteres'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('pt').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('pt').format(p['CHARACTER_LIMIT']) + ' caracteres') +
    '.',
  formControl_loading: () => 'Carregando',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Tamanho máximo ' + p['MAX_LENGTH'] + ' excedido.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' caracteres restantes.',
  formControl_month: () => 'Mês',
  formControl_readOnly: () => 'Somente para leitura',
  formControl_requiredMessageDetail: () => 'Digite um valor.',
  formControl_year: () => 'Ano',
  gantt_labelDate: () => 'Data',
  gantt_labelEnd: () => 'Fim',
  gantt_labelLabel: () => 'Label',
  gantt_labelRow: () => 'Linha',
  gantt_labelStart: () => 'Início',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nenhuma seção correspondente encontrada.',
  indexer_keyboardInstructionText: () => 'Pressione enter para selecionar um valor.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Entre ' + p['FROM_SECTION'] + ' e ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Toque duas vezes e mantenha para entrar no modo de gestos. Em seguida, arraste para cima ou para baixo para ajustar o valor.',
  info: () => 'Informações',
  inputDateMask_date_cleared: () => 'Data apagada',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Vazio',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'aaaa',
  inputNumber_converterParseError: () => 'Informe um número.',
  inputNumber_decrease: () => 'Reduzir',
  inputNumber_increase: () => 'Aumentar',
  inputPassword_hidden: () => 'Senha Oculta',
  inputPassword_hide: () => 'Ocultar Senha',
  inputPassword_show: () => 'Mostrar Senha',
  list_suggestion: () => 'Sugestão',
  messageToast_allMessagesClosed: () =>
    'Todas as mensagens de notificação do sistema foram fechadas.',
  message_close: () => 'Fechar',
  message_confirmation: () => 'Sucesso',
  message_error: () => 'Erro',
  message_info: () => 'Informações',
  message_navigationFromMessagesRegion: () =>
    'Entrando na área de mensagens. Pressione F6 para navegar de volta ao elemento focado anteriormente.',
  message_navigationToMessagesRegion: () =>
    'A área de mensagens tem novas mensagens. Pressione F6 para navegar até a área de mensagens mais recentes.',
  message_warning: () => 'Advertência',
  noData_message: () => 'Não há itens para exibição',
  overflowItemLabel: () => 'Mais Guias',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'Em Andamento',
  radio_helpForRadio: () => 'Ajuda para botão de opção',
  radio_requiredMessageDetail: () => 'Selecione um valor.',
  selectMultiple_apply: () => 'Aplicar',
  selectMultiple_back: () => 'Voltar',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Pressione Backspace or Delete para remover o valor selecionado.',
  selectMultiple_selectedValues: () => 'Valores selecionados',
  selectMultiple_showSelectedValues: () => 'Mostrar só os valores selecionados.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' valores selecionados.',
  select_addToList: () => 'Adicionar à lista',
  select_addToListAvailable: () => 'Adicionar à lista disponível',
  select_moreSearchOptions: () => 'Mais opções de pesquisa',
  select_moreSearchOptionsAvailable: () => 'Mais opções de pesquisa disponíveis',
  select_noMatchesFound: () => 'Nenhuma correspondência encontrada.',
  select_oneMatchFound: () => 'Uma correspondência encontrada',
  select_requiredMessageDetail: () => 'Selecione um valor.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' correspondências encontradas',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' ou mais correspondências encontradas',
  selector_selected: () => 'Caixa de seleção marcada',
  selector_unselected: () => 'Caixa de seleção não marcada',
  tabBarNavigationList_removeCueText: () => 'Removível',
  timeComponent_tooltipZoomIn: () => 'Mais Zoom',
  timeComponent_tooltipZoomOut: () => 'Menos Zoom',
  train_current: () => 'Atual',
  train_message_type: () => 'Tipo de Mensagem',
  train_not_visited: () => 'Não visitado',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Etapa ' + p['currentStep'] + ' de ' + p['numberOfSteps'],
  train_visited: () => 'Visitado',
  userAssistance_learnMore: () => 'Saiba mais',
  userAssistance_required: () => 'Obrigatório',
  viz_drillable: () => 'Disponível para drill',
  warn: () => 'Advertência'
};
export default bundle;
